import { AUTH, CLOSE_SOCKET, CREATE_SOCKET, LOGOUT, REPOPULATE, UPDATE_PROFILE } from '../constants/actionTypes';

const socketsReducer = (state = {}, action) => {

    switch (action.type) {

        case CREATE_SOCKET:

            return {
                ...state,
                [action.name] : action.socket
            }

        case CLOSE_SOCKET: 
            //socket should have been closed in actions, remove from state here
            
            return {
                ...state,
                [action.name]: null
            }

        default:
            return state; 
    }
}

export default socketsReducer; 